import { gate as v3gate } from 'hub-http/gates';
export const CONVERSATION_SUMMARY_GATE = 'Communication:AI:ConversationSummary';
export const LIMITED_TICKET_FUNCTION = 'HelpDesk:LimitedTicketFunctionInInbox';
export const HELP_DESK_ROUTING_SCOPE_FILTERING = 'HelpDeskRoutingScopeFiltering';
export const ROUTING_CAPACITY_LIMITS_DECOUPLING_GLOBAL = v3gate('Routing:UserLevelCapacityLimits:DecouplingGlobal');
export const USAGE_BASED_BILLING_INBOUND_2025 = v3gate('UsageBasedBilling:Inbound2025');